<template>
	<div class="ms-cell-editor">
		<div
			v-show="!isSelected || readOnly"
			class="flex-center"
			:class="{
				'edit-disabled': readOnly,
				'ms-editor-text': editable,
				'editor-input isValid': cellErrorProvider.isValid,
			}"
		>
			<div class="editor-display" :class="[`ms-text-${col.align}`]">
				<span>{{
					dataRow[col.dataField] | formatData({ formatType: col.formatType })
				}}</span>
			</div>
			<div
				class="icon-input float-right"
				v-tooltip="{ content: cellErrorProvider.message, classes: 'error' }"
				v-if="cellErrorProvider.isValid && !isSelected"
			>
				<div class="mi mi-24 mi-red-tick mr-2"></div>
			</div>
		</div>
		<div
			class="ms-editor w-full h-full"
			ref="editor"
			v-show="isSelected && !readOnly && editable"
		></div>
	</div>
</template>
<script>
import msCellInput from './msCellInput';
import msdatepicker from '@/components/msdatepicker/MsDatePicker.vue';
export default {
	name: 'msCellDatepicker',
	extends: msCellInput,
	data() {
		return {
			dataCached: {},
		};
	},
	methods: {
		/**
		 * Hàm để lấy component cần sử dụng
		 * @returns component được import để sử dụng
		 * Created by LTDAT(30.06.2020)
		 *  */
		getEditorControl() {
			return msdatepicker;
		},
		changeHandler(newVal, oldVal) {
			const me = this;
			let metaData = {
				dataRow: me.dataRow,
				column: me.col,
				newValue: newVal,
				oldValue: oldVal,
				cell: me,
			};
			me.$emit('change', metaData);
		},
		customValidate() {
			const me = this;
			let col = me.col,
				rulesValidate = null,
				ret = false;
			if (col.keyFromDate || col.keyToDate) {
				let message = null,
					fromDate = null,
					toDate = null;
				if (col.keyFromDate) {
					message =
						col.title +
						` ${me.$t('i18nCommon.conditionmaxorequal')} ` +
						col.keyTitleFromDate;
					fromDate = me.dataRow[col.keyFromDate];
					toDate = me.dataRow[col.dataField];
				}
				if (col.keyToDate) {
					message =
						col.title +
						` ${me.$t('i18nCommon.conditionminorequal')} ` +
						col.keyTitleToDate;
					fromDate = me.dataRow[col.dataField];
					toDate = me.dataRow[col.keyToDate];
				}
				if (fromDate && toDate) {
					let startDate = new Date(fromDate);
					let endDate = new Date(toDate);
					startDate.setHours(0, 0, 0);
					endDate.setHours(23, 59, 59);
					ret = !me.validateDateRange(startDate, endDate);
					me.setValid(ret, rulesValidate, message);
				}
			}
		},

		cellSelected() {
			const me = this;
			let colInfo = me.gridInfo.columns.find(
				(x) => x.dataField === me.col.dataField
			);
			if (!colInfo) return;

			let editor = colInfo[`__editor_${me.rowIndex}`];
			me.isSelected = true;

			//Trường hợp chưa khởi tại editor hoặc TH là 1 dòng mới(cần khởi tạo lại)
			if (!editor && me.$refs.editor) {
				editor = me.createdEditor();
			}
			if (editor) {
				editor.$cell = me;
				me.beforeEdit(editor);
				if (me.$refs.editor) {
					me.$refs.editor.innerHTML = '';
					me.$refs.editor.appendChild(editor.$el);
					me.focusEditor(editor);
				}
			}
		},

		setDataRowSelectCached() {
			const me = this;
		},
	},
};
</script>
<style lang="scss" scoped>
.editor-display {
	padding: 6px;
	flex: 1;
	overflow: hidden;
	text-overflow: ellipsis;
	width: 50px;
	overflow: hidden;
}
.ms-text-center {
	text-align: center !important;
}
</style>

